import { render, staticRenderFns } from "./UiNumberInput.vue?vue&type=template&id=434f0bd0&scoped=true&"
import script from "./UiNumberInput.vue?vue&type=script&lang=js&"
export * from "./UiNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./UiNumberInput.vue?vue&type=style&index=0&id=434f0bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f0bd0",
  null
  
)

export default component.exports